import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from "react";
import PropTypes from "prop-types";
import classNames from 'classnames';
import { formatModifiers } from "./utils";

function O2ControlWrapper(props) {
  var children = props.children,
      className = props.className,
      label = props.label,
      inline = props.inline,
      inlineVertical = props.inlineVertical,
      inlineLabel = props.inlineLabel,
      id = props.id,
      controlId = props.controlId,
      validationType = props.validationType,
      validationText = props.validationText,
      note = props.note,
      labelNote = props.labelNote,
      wrapperClassName = props.wrapperClassName,
      wrapperModifiers = props.wrapperModifiers,
      btnLeft = props.btnLeft,
      btnRight = props.btnRight,
      btnOver = props.btnOver,
      inputType = props.inputType,
      separator = props.separator,
      indentLeft = props.indentLeft,
      indentRight = props.indentRight,
      indentBottom = props.indentBottom,
      fakeLabel = props.fakeLabel,
      block = props.block,
      internal = props.internal,
      attributes = _objectWithoutPropertiesLoose(props, ["children", "className", "label", "inline", "inlineVertical", "inlineLabel", "id", "controlId", "validationType", "validationText", "note", "labelNote", "wrapperClassName", "wrapperModifiers", "btnLeft", "btnRight", "btnOver", "inputType", "separator", "indentLeft", "indentRight", "indentBottom", "fakeLabel", "block", "internal"]);

  var classes = classNames("o2-control__wrapper", className, wrapperClassName, formatModifiers(wrapperModifiers, "o2-control__wrapper"), inputType ? "o2-control__" + inputType : false, inline ? typeof inline === 'string' ? "o2-control__wrapper--inline-" + inline : 'o2-control__wrapper--inline' : false, inlineVertical ? "o2-control__wrapper--inline-" + inlineVertical : false, inlineLabel ? typeof inlineLabel === 'string' ? "o2-control__wrapper--inline-label-" + inlineLabel : 'o2-control__wrapper--inline-label' : false, {
    "o2-control__wrapper--button-left": btnLeft,
    "o2-control__wrapper--button-right": btnRight,
    "o2-control__wrapper--button-over": btnOver,
    "o2-control__wrapper--indent-left": indentLeft,
    "o2-control__wrapper--indent-right": indentRight,
    "o2-control__wrapper--indent-bottom": indentBottom,
    "o2-control__wrapper-separator": separator,
    "o2-control__wrapper--fake-label": fakeLabel,
    "o2-control__wrapper--block": block,
    "o2-control__wrapper--internal": internal
  });
  var content;

  if (btnLeft || btnRight || btnOver) {
    content = children;
  } else {
    content = /*#__PURE__*/React.createElement("div", {
      className: "o2-control__inner-container"
    }, children);
  }

  var wrapperId;

  if (id) {
    wrapperId = id;
  } else if (controlId) {
    wrapperId = controlId + '-control-wrapper';
  }

  return /*#__PURE__*/React.createElement("div", _extends({
    id: wrapperId,
    className: classes
  }, attributes), label && /*#__PURE__*/React.createElement("label", {
    className: "o2-control__label" + (inlineLabel ? " o2-control__label--inline" : ""),
    htmlFor: controlId
  }, label, labelNote && /*#__PURE__*/React.createElement("span", {
    className: "o2-control__label-note"
  }, labelNote)), content, note && /*#__PURE__*/React.createElement("div", {
    className: "o2-control__note"
  }, note), validationText && /*#__PURE__*/React.createElement("div", {
    className: "o2-control__validation o2-control__validation--" + (validationType || "error")
  }, validationText));
}

O2ControlWrapper.propTypes = {
  children: PropTypes.node,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  className: PropTypes.string,
  inline: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(["md"])]),
  inlineVertical: PropTypes.oneOf(["top", "middle", "bottom"]),
  inlineLabel: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(["lg"])]),
  id: PropTypes.string,
  controlId: PropTypes.string,
  validationType: PropTypes.oneOf(["error", "warning", "success", false]),
  validationText: PropTypes.string,
  note: PropTypes.string,
  labelNote: PropTypes.string,
  wrapperModifiers: PropTypes.string,
  btnLeft: PropTypes.bool,
  btnRight: PropTypes.bool,
  btnOver: PropTypes.bool,
  indentLeft: PropTypes.bool,
  indentRight: PropTypes.bool,
  indentBottom: PropTypes.bool,
  inputType: PropTypes.string,
  separator: PropTypes.bool,
  fakeLabel: PropTypes.bool,
  block: PropTypes.bool,
  internal: PropTypes.bool
};
export default O2ControlWrapper;